import {RouterProvider} from 'react-router-dom';

import RootProviders from '@/providers/RootProviders';
import router from '@/router';

const App = () => (
  <RootProviders>
    <RouterProvider router={router} />
  </RootProviders>
);
export default App;
